import React from "react";
import { GatsbyImage as Image, getImage } from "gatsby-plugin-image";

export default function SlideWithImageCard({ data }) {
  const { backgroundImage, title, slideContent } = data;
  return (
    <div className="w-full hds-container" style={{ height: "80vh" }}>
      <div
        className={`${
          !backgroundImage && "bg-gray-300"
        } w-full h-full absolute right-0 inset-y-0 overflow-hidden`}
      >
        {backgroundImage && (
          <Image
            className="w-full h-full object-cover object-center"
            image={getImage(backgroundImage)}
            alt={backgroundImage.alt ? backgroundImage.alt : ""}
          />
        )}
      </div>

      <div className="hds-section image-card-slide-content h-full">
        <div className="grid md:grid-cols-2 gap-3 md:gap-20 h-full">
          <div className="flex flex-col md:justify-end">
            {/* Slide Title */}
            <h3 className="text-4xl md:text-5xl font-a3 text-white md:w-104">
              {title}
            </h3>
          </div>
        </div>
      </div>
    </div>
  );
}
